import { render, staticRenderFns } from "./SimpleSwitch.vue?vue&type=template&id=32171724"
import script from "./SimpleSwitch.vue?vue&type=script&lang=js"
export * from "./SimpleSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports